import { MapContext } from 'contexts/MapContext';
import * as RiIcons from 'react-icons/ri';
import React, { useContext, useMemo, useEffect, useState } from 'react';
import { useLayers } from 'hooks/useLayers';

import VectorLayer from 'ol/layer/Vector';
import { ToolBox } from 'screens/Dashboard/components/SideBar/ToolBox';
import { BaseSelect } from 'components/BaseSelect';

function getName(str: string) {
  const key = 'p3m:';
  const index = str?.indexOf(key);
  return index !== -1 ? 'p3m:' + str?.slice(index + key.length) : '';
}

function getLayerId(layer: any): string {
  const props = layer?.getProperties?.() ?? {};

  if (props.layertitle) return String(props.layertitle);
  if (props.uuid) return String(props.uuid);

  return '';
}

export function TranslateFeaturesMenu() {
  const { getLayerAttritubeByName } = useLayers();

  const {
    map,
    translateLayer,
    handleSetTranslateLayer,
  } = useContext(MapContext);

  const [layersVersion, setLayersVersion] = useState(0);

  useEffect(() => {
    if (!map) return;
    const layers = map.getLayers();
    const onAdd = () => {
      setLayersVersion(v => v + 1);
    };
    layers.on('add', onAdd);
    return () => {
      layers.un('add', onAdd);
    };
  }, [map, handleSetTranslateLayer]);

  const vectorLayers = useMemo(() => {
    if (!map) return [];

    return map
      .getLayers()
      .getArray()
      .filter((layer: any) => {
        if (!(layer instanceof VectorLayer)) return false;

        const props = layer?.getProperties?.() ?? {};
        return !!(props.layertitle || props.uuid);
      });
  }, [map, layersVersion]);

  const selectedId = translateLayer ? getLayerId(translateLayer) : '';

  function getLayerLabel(layer: any) {
    const id = getLayerId(layer);
    const meta = getLayerAttritubeByName(getName(id))?.layertitle || id;
    // remove extensão tipo .geojson
    return meta.replace(/\.(kml|geojson|zip|shp)$/i, '');
  }

  return (
    <ToolBox
      header={
        <>
          <RiIcons.RiDragMoveLine />
          <span>Mover Feições</span>
        </>
      }
    >
      <BaseSelect
        label='Camada vetorial'
        value={selectedId || 'disable'}
        onChange={handleSetTranslateLayer}
        placeholder={'Selecione a camada'}
        options={vectorLayers.map(l => ({
          label: getLayerLabel(l), value: getLayerId(l),
        }))}
      />
    </ToolBox>
  );
}